import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Instructions from '../../components/Instructions';
import ContentExplorer from '../../components/ContentExplorer';
import ContentPickerPopup from '../../components/ContentPickerPopup';
import HelpModal from '../../components/Modals/Help';
import { removeCookie } from '../../utils/cookies';
import SessionExpiredModal from '../../components/Modals/SessionExpired';
import { getLogoutURI } from '../../utils/api';

export default function ({sessionExpiredModalOpen}) {
  const [helpModalOpen, setHelpModalOpen] = useState(false);

  const downloadFile = (downloadUrl) => {
    var iframe = document.createElement('iframe');
    iframe.style.display = "none";
    iframe.src = downloadUrl;
    document.body.appendChild(iframe);
  };

  return (
    <div>
      <Header
        openHelpModal={() => setHelpModalOpen(true)}
      />

      <div className="flex tabs fill height-fill margin-top-100" style={{ minHeight: 650 }}>
        <h1 className="text-center color-blue margin-bottom-30">Commercial Mortgage Lending Portal</h1>
        <div className="flex">
          <Instructions />
          <div className="grow right-panel-container">
            <div>
              <ContentPickerPopup onDownload={downloadFile} />
            </div>
            <ContentExplorer />
          </div>
        </div>
      </div>

      <Footer />

      <HelpModal
        open={helpModalOpen}
        onClose={() => setHelpModalOpen(false)}
      />

      <SessionExpiredModal
        open={sessionExpiredModalOpen}
        onClose={async () => {
          removeCookie('boxToken');
          removeCookie('cognitoToken');
          await getLogoutURI();
        }}
      />
    </div>
  );
}
